import React from 'react';

const ErrorState = ({ message, onRetry }) => (
  <div className="flex items-center justify-center h-72 md:h-80 lg:h-96">
    <div className="text-center">
      <div className="text-red-500 text-base md:text-lg font-medium mb-2">
        Error Loading Data
      </div>

      <div className="text-gray-600 text-sm md:text-base">
        {message}
      </div>

      <button
        onClick={onRetry}
        className="mt-4 px-4 py-2 text-sm md:text-base bg-indigo-600 text-white rounded-lg hover:bg-indigo-700"
      >
        Retry
      </button>
    </div>
  </div>
);

export default ErrorState;
